import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const JitFallback = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Skeleton className="h-5.5 w-55 mb-0.5" />
        </CardTitle>
        <CardAction>
          <div className="flex gap-2">
            <Skeleton className="h-9 w-45" />
            <Skeleton className="h-9 w-21.5" />
          </div>
        </CardAction>
        <CardDescription className="space-y-1">
          <Skeleton className="h-4.5 w-200" />
          <Skeleton className="h-4.5 w-60" />
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Skeleton className="h-6 w-60" />
      </CardContent>
    </Card>
  )
}
